import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScProviders = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;

  @media (${device.mobile}) {
    gap: 4px;
    flex-wrap: wrap;
  }

  & .providers-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: ${({ theme }) => theme.darkIndigo};
    padding: 12px 4px;
    border-radius: 12px;
    width: 100%;
    max-width: 200px;
    justify-content: center;

    @media (${device.mobile}) {
      gap: 4px;
      max-width: 114px;
      height: 56px;
      & .provider-img {
        height: 22px;
        width: 22px;
      }
    }
    .provider-name {
      text-transform: uppercase;
      font-size: 18px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: 0.4px;
      color: #9a9cac;
      @media (${device.mobile}) {
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0;
        text-transform: capitalize;
      }
    }
  }
`;
